module.exports = __webpack_public_path__ + "static/media/essentialnutrientswithoutiron1.d5712d12.pdf";